import { apiClient } from "../api/apiClient";

import {
  Blog,
  ApiResponse,
  CreateBlogRequest
} from "../interfaces/Blog";

export const blogService = {

    

  // ==========================
  // GET ALL
  // ==========================

  getAll: async (): Promise<Blog[]> => {

    const response =
      await apiClient.get<
        ApiResponse<Blog[]>
      >("/Blogs");

    const result =
      response.data;

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.dataList || [];
  },

  // ==========================
  // GET BY ID
  // ==========================

  getById: async (
    id:number
  ): Promise<Blog> => {

    const response =
      await apiClient.get<
        ApiResponse<Blog>
      >(`/Blogs/${id}`);

    const result =
      response.data;

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.data;
  },

  // ==========================
  // CREATE
  // ==========================

create: async (payload: CreateBlogRequest) => {

  const formData = new FormData();

  // ==========================
  // BASIC INFO
  // ==========================
  formData.append("BlogTitle", payload.blogTitle);
  formData.append("BlogSlug", payload.blogSlug);
  formData.append("ShortDescription", payload.shortDescription);
  formData.append("BlogContent", payload.blogContent);

  formData.append("AuthorName", payload.authorName);
  payload.tags?.forEach(tag => {
  formData.append("Tags", tag);
});

  // ==========================
  // STATUS / DATE
  // ==========================
  formData.append("Status", payload.status);
  formData.append("PublishDate", payload.publishDate);

  // ==========================
  // SEO
  // ==========================
  formData.append("MetaTitle", payload.metaTitle || "");
  formData.append("MetaDescription", payload.metaDescription || "");
  formData.append("MetaKeywords", payload.metaKeywords || "");
  formData.append("CanonicalUrl", payload.canonicalUrl || "");

  // ==========================
  // OG
  // ==========================
  formData.append("OgTitle", payload.ogTitle || "");
  formData.append("OgDescription", payload.ogDescription || "");
  formData.append("OgImage", payload.ogImage || "");

  // ==========================
  // EXTRA
  // ==========================
  formData.append("SchemaMarkup", payload.schemaMarkup || "");

  // ==========================
  // FILE
  // ==========================
  if (payload.blogImage) {
    formData.append("BlogImage", payload.blogImage);
  }
  debugger

 const response = await apiClient.post(
  "/Blogs/Create",
  formData,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);
debugger
const result = response.data;

console.log("Create API Response:", result);

if (!result.isSuccess) {
  throw new Error(
    result.message || "Failed to create blog"
  );
}

return result.data;

},


  // ==========================
  // CONTENT IMAGE
  // ==========================

 uploadContentImage: (
  formData: FormData
) => {
    debugger
  return apiClient.post(
    "/Blogs/upload-content-image",
    formData,
    {
      headers: {
        "Content-Type":
          "multipart/form-data"
      }
    }
  );
},
  // ==========================
  // DELETE
  // ==========================

  delete: async (
    id:string
  ) => {

    const response =
      await apiClient.delete(
        `/Blogs/${id}`
      );

    return response.data;
  },
  // ==========================
// UPDATE
// ==========================

update: async (id: string, payload: Partial<CreateBlogRequest>) => {
debugger
  const formData = new FormData();

  // BASIC INFO
  formData.append("BlogID", id || "");
  formData.append("BlogTitle", payload.blogTitle || "");
  formData.append("BlogSlug", payload.blogSlug || "");
  formData.append("ShortDescription", payload.shortDescription || "");
  formData.append("BlogContent", payload.blogContent || "");

  formData.append("AuthorName", payload.authorName || "");
 payload.tags?.forEach(tag => {
  formData.append("Tags", tag);
});

  // STATUS / DATE
  formData.append("Status", payload.status || "Draft");
  formData.append("PublishDate", payload.publishDate || "");

  // SEO
  formData.append("MetaTitle", payload.metaTitle || "");
  formData.append("MetaDescription", payload.metaDescription || "");
  formData.append("MetaKeywords", payload.metaKeywords || "");
  formData.append("CanonicalUrl", payload.canonicalUrl || "");

  // OG
  formData.append("OgTitle", payload.ogTitle || "");
  formData.append("OgDescription", payload.ogDescription || "");
  formData.append("OgImage", payload.ogImage || "");

  // EXTRA
  formData.append("SchemaMarkup", payload.schemaMarkup || "");

  // FILE (IMPORTANT)
  if (payload.blogImage instanceof File) {
    formData.append("BlogImage", payload.blogImage);
  }

  const response = await apiClient.put(
    `/Blogs/Update`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
},

};